interface DocumentFrameProps {
  html: string;
}

const PROSE_STYLES = `
  :root { color-scheme: light; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; }
  body {
    background: #ffffff;
    color: #1a1a1a;
    font-family: 'Apple SD Gothic Neo', 'Noto Serif KR', Georgia, 'Times New Roman', serif;
    font-size: 17px;
    line-height: 1.85;
    -webkit-font-smoothing: antialiased;
  }
  .doc {
    max-width: 720px;
    margin: 0 auto;
    padding: 40px 32px 96px;
    word-break: break-word;
  }
  .doc p { margin: 0 0 1em; }
  .doc h1, .doc h2, .doc h3, .doc h4 { font-weight: 700; line-height: 1.35; margin: 1.6em 0 0.6em; }
  .doc h1 { font-size: 1.6em; }
  .doc h2 { font-size: 1.35em; }
  .doc h3 { font-size: 1.15em; }
  .doc img, .doc video { max-width: 100%; height: auto; }
  .doc blockquote { margin: 1em 0; padding: 0.2em 1em; border-left: 3px solid #d4d4d4; color: #555; }
  .doc ul, .doc ol { margin: 0 0 1em; padding-left: 1.5em; }
  .doc li { margin: 0.2em 0; }
  .doc a { color: #2563eb; text-decoration: underline; }
  .doc hr { border: none; border-top: 1px solid #e5e5e5; margin: 2em 0; }
  .doc table { border-collapse: collapse; max-width: 100%; }
  .doc td, .doc th { border: 1px solid #d4d4d4; padding: 6px 10px; }
  .doc pre { white-space: pre-wrap; background: #f5f5f5; padding: 12px; border-radius: 6px; overflow-x: auto; }
`;

export function DocumentFrame({ html }: DocumentFrameProps) {
  if (!html.trim()) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-muted-foreground">
        내용이 없습니다.
      </div>
    );
  }

  const srcDoc = `<!doctype html><html lang="ko"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style>${PROSE_STYLES}</style></head><body><article class="doc">${html}</article></body></html>`;

  return (
    <iframe
      title="문서 본문"
      sandbox=""
      srcDoc={srcDoc}
      className="w-full flex-1 border-0 bg-white"
    />
  );
}
